import Axios from "axios";
import { DATABASE_URL, SECURITY_FLAG_LIMIT } from "../appConstants";

const toNumber = (value) => Number(value || 0);

const normalizeSecurityPayload = (payload = {}) => {
  const numberOfWarnings = toNumber(payload.number_of_warnings);
  const status = payload.status === undefined ? undefined : toNumber(payload.status);
  const completedTest = toNumber(payload.completed_test);

  return {
    numberOfWarnings,
    status,
    completedTest,
    suspended:
      Boolean(payload.suspended) ||
      status === 0 ||
      numberOfWarnings >= SECURITY_FLAG_LIMIT ||
      (completedTest === 1 && numberOfWarnings >= SECURITY_FLAG_LIMIT),
  };
};

export const getTestSecurityStatus = async (candidateId) => {
  const response = await Axios.get(
    `${DATABASE_URL}/auth/user_test_warnings/${candidateId}`
  );

  return normalizeSecurityPayload(response.data.payload);
};

export const recordTestSecurityWarning = async (candidateId) => {
  const response = await Axios.post(
    `${DATABASE_URL}/auth/user_test_warnings/${candidateId}`
  );

  return normalizeSecurityPayload(response.data.payload);
};
